import React from "react"
import PropTypes from "prop-types"

import iosSvg from "images/home/new_home/ios_download.svg"
import androidSvg from "images/home/new_home/google_play.svg"

export default class AppDownloadButton extends React.Component {
  render() {
    let appInfo
    const ios = {
      type: "ios",
      icon: iosSvg,
      url: this.props.appStorePath,
    }
    const android = {
      type: "android",
      icon: androidSvg,
      url: this.props.googlePlayStorePath,
    }

    if (this.props.applet.applet_type === "ios") {
      appInfo = ios
    } else if (this.props.applet.applet_type === "android") {
      appInfo = android
    } else if (this.props.userDevice === "android") {
      appInfo = android
    } else {
      appInfo = ios
    }

    return (
      <span
        dangerouslySetInnerHTML={{ __html: appInfo.icon }}
        data-track-ifttt-next-event="click"
        data-track-data={JSON.stringify({
          object_type: "mobile_alert.app_download_button",
          object_id: `icon.${appInfo.type}`,
          location_type: "connection",
          connection_id: this.props.applet.id,
        })}
        onClick={() => {
          window.open(appInfo.url, "_blank")
        }}
      />
    )
  }
}

AppDownloadButton.propTypes = {
  applet: PropTypes.shape({
    id: PropTypes.string,
    applet_type: PropTypes.string,
  }),
  appStorePath: PropTypes.string.isRequired,
  googlePlayStorePath: PropTypes.string.isRequired,
  userDevice: PropTypes.string.isRequired,
}
